import { defineComponent as _defineComponent } from 'vue'
import VsButton from '@/components/vision/VsButton.vue'
import VsText from '@/components/vision/VsText.vue'
import VsWrapper from '@/components/vision/VsWrapper.vue'
import { ref } from 'vue'
import * as Sentry from '@sentry/vue'
import { useGetters } from 'vuex-composition-helpers'


export default /*#__PURE__*/_defineComponent({
  __name: 'FeedbackDialog',
  props: {
    title: { default: 'Feedback' },
    subtitle: { default: 'Tell us about your experience using IronSight' }
  },
  emits: ["close"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'close')
}), expose: any, slots: any, attrs: any }) {

const props = __props as { title: string, subtitle: string }





const comments = ref<string>()

const { getContext: currentUserContext } = useGetters('permissions', [
  'getContext',
])

const cancel = () => {
  emits('close')
}

const submit = () => {
  const eventId = Sentry.captureException(
    new Error('User Feedback Submitted: ' + new Date().toISOString())
  )

  const userFeedback = {
    event_id: eventId,
    name: currentUserContext.value.name,
    email: currentUserContext.value.email,
    comments: comments.value!,
  }

  Sentry.captureUserFeedback(userFeedback)
  emits('close')
}

return { __sfc: true,props, emits, comments, currentUserContext, cancel, submit, VsButton, VsText, VsWrapper }
}

})